// Cosmetic-only label overrides; underlying data/filter values are untouched
const SPECIAL_NOTE_DISPLAY_LABELS = {
  'ZipDrug Claims': 'CPTC Claims',
};

const getSpecialNoteDisplayLabel = note => SPECIAL_NOTE_DISPLAY_LABELS[note] || note;

export default getSpecialNoteDisplayLabel;
